import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { ConfirmationModalComponent } from '../confirmation/confirmation-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  setFocusToCurrentInput = new Observable<boolean>();
  state: any;
  updatePageSubject: Subject<null> = new Subject<null>();

  constructor(
    private router: Router,
    private modalService: NgbModal
  ) { }

  public unSavedChangesConfirm: boolean = false;
  public ngModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    size: 'm'
  };

  unSaveConfirm = (state: RouterStateSnapshot, ignoreState: boolean = false): boolean => {
    if (this.unSavedChangesConfirm) {
      const modalRef = this.modalService.open(ConfirmationModalComponent);
      modalRef.componentInstance.title = 'Confirmation';
      modalRef.componentInstance.body = 'You have unsaved changes. Do you want to leave this page?';
      this.state = state;
      const that = this;
      modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
        if (!outcome) {
          this.setFocusToCurrentInput = of(true);
          modalRef.close();
        } else {
          this.unSavedChangesConfirm = false;
          modalRef.close();
          if (!ignoreState) {
            if (that.state?.url) {
              this.router.navigate([that.state?.url], {queryParams: this.buildQueryParams()});
            }
          }
        }
        return outcome;
      });
      return false;
    } else {
      return true
    }
  }

  public unSavedChangeConfirmation(callBack: any, confirmationMessage: string): void {
    if (this.unSavedChangesConfirm) {
      const modalRef = this.modalService.open(ConfirmationModalComponent);
      modalRef.componentInstance.title = 'Confirmation';
      modalRef.componentInstance.body = confirmationMessage;
      modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
        if (!outcome) {
          this.setFocusToCurrentInput = of(true);
          modalRef.close();
        } else {
          this.unSavedChangesConfirm = false;
          modalRef.close();
          callBack();
        }
      });
    } else {
      callBack();
    }
  }

  public generalConfirmation(callBack: any, confirmationMessage: string): void {
    const modalRef = this.modalService.open(ConfirmationModalComponent);
    modalRef.componentInstance.title = 'Confirmation';
    modalRef.componentInstance.body = confirmationMessage;
    modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
      if (!outcome) {
        modalRef.close();
      } else {
        modalRef.close();
        callBack();
      }
    });
  }


  // buildPageQuery = (p: FindPartsQueryParameters, o: string[]): string => {


  //   let queryString = '';
  //   let parameter: keyof typeof p; 
  //   for (parameter in p) {
  //     if (p[parameter]) {
  //       queryString += `${parameter}=${p[parameter]}&`
  //     }
  //   }

  //   return encodeURI(queryString.slice(0, queryString.length - 1));

  // }

  // languageQuery = (beginWith:string): string => {

  //   return `${beginWith ? beginWith : ''}language=${region.language.id}`

  // }

  areCookiesEnabled = () => {
    let cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
    }

    return (cookieEnabled);
  }

  isObjInArray = (key: string, val: any, array: any[]) => {

    for (var i = 0; i < array.length; i++) {

      if (array[i][key] == val) {
        return true
      } else if (i == (array.length - 1)) {
        return false
      }

    }

    return false;

  }

  getObjects = (obj: any, key: string, val: any) => {
    var objects: any[] = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] == 'object') {
        objects = objects.concat(this.getObjects(obj[i], key, val));
      } else
        //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
        if (i == key && obj[i] == val || i == key && val == '') { //
          objects.push(obj);
        } else if (obj[i] == val && key == '') {
          //only add if the object is not already in the array
          if (objects.lastIndexOf(obj) == -1) {
            objects.push(obj);
          }
        }
    }
    return objects;
  }

  compileSubSectionIds = (p: any) => {

    let sectionIdsSubSectionIds = [];

    if (p.query && (p.query.sectionIds || p.query.subSectionIds)) {
      //combine sectionIds and subSectionIds into one array
      let sectionIds;
      if (p.query.sectionIds) {
        sectionIds = JSON.parse(p.query.sectionIds);
      }

      let subSectionIds;
      if (p.query.subSectionIds) {
        subSectionIds = JSON.parse(p.query.subSectionIds);
      }

      if (sectionIds && sectionIds.length) {
        for (let i = 0; i < sectionIds.length; i++) {
          sectionIdsSubSectionIds.push(sectionIds[i]);
        }
      }

      if (subSectionIds && subSectionIds.length) {
        for (let x = 0; x < subSectionIds.length; x++) {
          sectionIdsSubSectionIds.push(subSectionIds[x]);
        }
      }

      return sectionIdsSubSectionIds;

    }

    return null;

  }

  notice = (text: string): void => {
    alert(text)
  }

  public buildNavExtras = (activatedRoute: ActivatedRoute, newQueryParams?: any, relativeTo?: boolean): NavigationExtras => {


    let n: NavigationExtras = {
      queryParams: this.buildQueryParams(activatedRoute, newQueryParams)
    }

    if(relativeTo){
      n.relativeTo = activatedRoute;
    }

    return n;

  }

  public buildQueryParams = (activatedRoute?:ActivatedRoute, newQueryParams?: any): any => {

    let existingParamsToKeep: any = {};

    if(activatedRoute && activatedRoute?.snapshot.queryParams.branch){
      existingParamsToKeep.branch = activatedRoute?.snapshot.queryParams.branch; //critical so keep this
      existingParamsToKeep.language = activatedRoute?.snapshot.queryParams.language; //critical so keep this
      existingParamsToKeep.publicContext = activatedRoute?.snapshot.queryParams.publicContext; //critical so keep this
      existingParamsToKeep.jwtContext = activatedRoute?.snapshot.queryParams.jwtContext; //critical so keep this
      existingParamsToKeep.brandContext = activatedRoute?.snapshot.queryParams.brandContext; //critical so keep this
    }
    let q: any = {
      ...existingParamsToKeep, //keep existing params
      ...newQueryParams //new params given to us that we only need for a single route change
    }

    return q;

  }

  public sortArrayObjectsAlphabetically = (array: any[], propertyNameToSortBy: string): any[] => {
    return array.sort(function(a, b){
      if(a[propertyNameToSortBy] < b[propertyNameToSortBy]) { return -1; }
      if(a[propertyNameToSortBy] > b[propertyNameToSortBy]) { return 1; }
      return 0;
    })
  }
}
